<template>
  <div>
    <b-form>
      <label>{{categoryName}}</label>
      <b-button size="sm" class="component-margin-left-half" @click="showModal" variant="warning">カテゴリ検索</b-button>
    </b-form>
    <b-form v-if="categoryWarningMessage != ''">
      <label class="mark bkcolor-red">注意：<span>{{categoryWarningMessage}}</label>
    </b-form>
    <b-modal ref="categorySelectModel" title="カテゴリ検索" size="lg" hide-footer=true>
      <b-row class="component-margin">
        <b-col sm="8">
          <b-input v-model="filter" placeholder="カテゴリ名(英)、カテゴリ名(日)"/>
        </b-col>
        <b-col sm="4">
          <b-button size="sm" @click="removeSelectCategory()" variant="danger">指定を解除する</b-button>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12">
          <b-table show-empty stacked="md" bordered=true striped=true small=true hover=true
                  :items="filteredItems" :fields="fields"
                  :current-page="currentPage" :per-page="perPage">
            <template slot="select" slot-scope="row">
              <b-button size="sm" @click="selectCategory(row)" variant="danger">選択</b-button>
            </template>
          </b-table>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12">
          <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage"/>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import * as api from '@/api';

export default {
  props: {
    selectedMemberFromManage: { default: ''},
    categoryName: { default: '-'},
    isRequiredReceipt: { default: '0'},
    carrier: { default: ''},
    lasNumber: { default: '0'},
    categoryWarningMessage: { default: ''}
  },
  data() {
    return {
      items: [],
      fields: [
        { key: 'categoryName', label: 'カテゴリ名(英)', sortable: false, variant: 'base', class: 'table-lw12' },
        { key: 'categoryNameJp', label: 'カテゴリ名(日)', sortable: false, variant: 'base', class: 'table-lw12' },
        { key: 'hscode', label: 'HSコード', sortable: false, variant: 'base', class: 'table-lw8' },
        // { key: 'dcustomRate', label: '関税率', sortable: false, variant: 'base', class: 'table-rw12' },
        { key: 'materialName', label: '材料', sortable: false, variant: 'base', class: 'table-rw12' },
        { key: 'select', label: '選択', sortable: false, variant: 'base', class: 'table-cw5' },
      ],
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      filter: '',
      selectedMember: '',
      sellerType: '0'
    };
  },
  computed: {
    filteredItems() {
      let filteredItems = this.items.filter(item => {
        return ((this.filter === '' || item.categoryName.toUpperCase().indexOf(this.filter.toUpperCase()) !== -1) ||
                (this.filter === '' || item.categoryNameJp.toUpperCase().indexOf(this.filter.toUpperCase()) !== -1));
        });
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
      return filteredItems;
    },
  },
  // created() {
  //   api.getCategoryMaster((data) => {
  //     this.items = data.categoryMasterList
  //     this.totalRows = this.items.length;
  //   });
  // },
  methods: {
    showModal() {
      this.filter = '';
      api.getCategoryMaster((data) => {
        this.items = data.categoryMasterList
        this.totalRows = this.items.length;
        this.$refs.categorySelectModel.show();
      });
    },
    hideModal() {
      this.$refs.categorySelectModel.hide();
    },
    selectCategory(row) {
      this.categoryName = row.item.categoryName;
      this.$emit('selectedCategory', row.item.categoryId);
      this.$emit('selectedCategoryName', row.item.categoryName);
      this.hideModal();
    },
    removeSelectCategory() {
      this.categoryName = '-';
      this.$emit('selectedCategory', 0);
      this.$emit('selectedCategoryName', '-');
      this.hideModal();
    },
  },
};
</script>

<style>
.component-margin-left-half {
  margin-left: .5rem;
}
.margin-left {
  margin-left: 1rem;
}
.component-margin {
  margin-bottom: 1rem;
}
.mark-red {
    background-color: red;
    color: white;
    border-radius: 0.5rem;
    font-size: 0.8rem;
}
.mark-blue {
    background-color: blue;
    color: white;
    border-radius: 0.5rem;
    font-size: 0.8rem;
}
.mark-green {
    background-color: green;
    color: white;
    border-radius: 0.5rem;
    font-size: 0.8rem;
}
.mark-yellow {
    background-color: yellow;
    color: black;
    border-radius: 0.5rem;
    font-size: 0.8rem;
}
.mark-gray {
    background-color: gray;
    color: white;
    border-radius: 0.5rem;
    font-size: 0.8rem;
}
.mark-yellow2 {
    background-color: yellow;
    color: black;
    border-radius: 0.2rem;
    font-size: 0.8rem;
    border: 1px solid #607D8B;
}

@media (min-width: 768px) {
  .modal-lg {
    max-width: 1000px;
  }
  .table-label div {
    transform: translateY(0.3rem);
  }
  .table-cw4 {
    min-width: 4rem;
    max-width: 4rem;
    width: 4rem;
    text-align:center!important;
  }
}
</style>
